import {
    IListProductProps, ListProductReferrer
} from '../../list-page/interfaces/interfaces';
import StarRating from '../../../ui/rating/star-rating';
import ProductListPrices from '../product-price/product-list-prices';
import ProductImage from '../product-image/product-image';
import ProductTitle from '../product-title/product-title';
import {getIsChina} from '../../../domain/hidden-data-provider';
import { sendGAEventAddToCart, sendGAListPageEvent } from '../../../domain/marketing/gtm-provider';
import ProductListPricesMerch from '../product-price/product-list-prices-merch';
import ProductBuyButton from '../product-buy-button/product-buy-button';
import CompareProducts from '../compare/compare-products';
import ProductSubscriptionTiersTextABTEST from "../subscription/sbs-tiers-text-abtest";
import {useState} from "react";
import {PlansPopupExported} from "../../subscriptions/components/plugins-popup/plans-popup-exported";
import ProductListPricingAreaSbsBtn from '../subscription/product-list-pricing-area-sbs-btn';
import ProductPriceFormat from '../product-price/product-price-format';
import { outbrainAddToCartEvent } from '../../../domain/marketing/outbrain-provider';
import { ProductDepartmentEnum } from '../enums/product-department-enum';

/**
 * Grid product item.
 * Used in list pages, in the grid view mode.
 */
const ListProduct = (props: IListProductProps) => {

    const product = props.product;
    const isRatingVisible = product.rating > 0 && !getIsChina();
    const isExpectedShipping = product.expectedShipping ? product.expectedShipping : '' ;
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
    const isIllugen = product.documentName.toLowerCase().includes('illugen');
    const isWavesStream = product.documentName.toLowerCase().includes('waves stream');

    const sendAddToCartEvents = () => {
        sendGAEventAddToCart(
            product.documentName,
            product.skuNumber,
            product.skuPrice,
            product.documentUrlPath,
            props.listName ? props.listName : 'List Page'
        );

        outbrainAddToCartEvent();
    };

    return (
        <div
            key={ product.nodeID }
            className="list-item text-base text-gray-700 flex relative"
            data-order={ product.mainOrder }
            data-docid={ product.documentID }>

            <ProductImage {...props} classes="mr-8" style={{
                width: '250px'
            }} />

            <div className="flex-1 mr-8">

                <ProductTitle product={ product } removeTitleLink={ props.removeTitleLink } />

                <div className="text-gray-500 mb-2" style={{
                    maxWidth: '430px'
                }}>{ props.product.documentPageDescription }</div>

                {
                    isRatingVisible &&
                    <div onClick={ evt => {
                        sendGAListPageEvent(product); // TODO: check inner GA events!!!
                    }}>
                        <StarRating
                            rating={ product.rating }
                            reviews={ product.reviewsTotal }
                            url={ product.documentUrlPath }
                            urlHash={ 'tab-reviews' }
                            className="mb-4"
                        />
                    </div>
                }
            </div>
            <div className="w-1/5">
                <div className="mb-4" onClick={ () => {
                    sendGAListPageEvent(product);
                }}>
                    {
                        props.buttonsABCDAbTest !== 'perpetual-link' &&
                        <>
                            {/*
                                !props.isIncludedInHidden && !product.note && !product.isProductOptions && sbsIncludedIn &&
                                <ProductSubscriptionTiers product={ product } isGrid={ false } />
                            */}

                            {
                                !product.note && !product.isProductOptions && product.skuEnabled && /* product.sbsIncludedIn === 0 && */
                                <ProductListPrices product={ product } isGoogleShoppingFeed={ props.isGoogleShoppingFeed } />
                            }

                            {
                                !product.note && product.isProductOptions &&
                                <ProductListPricesMerch product={ product } />
                            }
                        </>
                    }

                    {/* expected shipping */}
                    { !props.isAccountPage && <div>{isExpectedShipping}</div> }
                </div>

                {/* buy button */}
                {
                    (!props.isAccountPage && product.note) &&
                    <div dangerouslySetInnerHTML={{__html: product.note}} />
                }

                {
                    (!product.note || props.isAccountPage) &&
                    <div className="flex flex-col gap-4">
                        {
                            (props.buttonsABCDAbTest !== 'perpetual-link' || isIllugen || isWavesStream) &&
                            <ProductBuyButton
                                product={ product }
                                listName={ props.listName }
                                btnClasses={ 'w-btn-outline-black w-48 block px-8 md:px-10' }
                            />
                        }

                        {
                            props.referrer === ListProductReferrer.ListPage &&
                            props.buttonsABCDAbTest !== 'old' &&
                            product.departmentID !== ProductDepartmentEnum.Subscription &&
                            (product.sbsIncludedIn || 0) > 0 &&
                            <ProductListPricingAreaSbsBtn
                                documentName={ product.documentName }
                                skuId={ product.skuid }
                                setShowSubscriptionPopup={ setShowSubscriptionPopup }
                                classes={ props.buttonsABCDAbTest === 'yellow-sbs' ? 'w-btn w-48 inline-block px-8 md:px-10 bg-yellow-200 text-black' : 'w-btn-outline-black w-48 inline-block px-8 md:px-10' }
                            />
                        }
                    </div>
                }

               {/* {
                    !!product.sbsIncludedIn &&
                    !props.isSbsTextHidden &&
                    !props.isButtonAndNoteHidden &&
                    props.buttonsABCDAbTest === 'old' &&
                    <ProductSubscriptionTiersTextABTEST
                        product={ product }
                        returnFunc={() => setShowSubscriptionPopup(true)}
                    />
                }*/}

                {
                    !props.isSbsTextHidden &&
                    !props.isButtonAndNoteHidden &&
                    /*<ProductSubscriptionTiersText product={ product } /> */
                    <>
                        {
                            props.buttonsABCDAbTest === 'old' &&
                            <ProductSubscriptionTiersTextABTEST
                                product={ product }
                                returnFunc={() => setShowSubscriptionPopup(true)}
                            />
                        }

                        {
                            !product.note &&
                            props.buttonsABCDAbTest === 'perpetual-link' &&
                            !isIllugen &&
                            !isWavesStream &&
                            <div className="text-sm mt-4" data-cart="open">
                                {
                                    (product.sbsIncludedIn || 0) > 0 &&
                                    <span className="mr-1">or</span>
                                }

                                <a href={ `/cart?productid=${ product.skuid }` }
                                   onClick={ sendAddToCartEvents }
                                   className={ props.classes }
                                   data-skunumber={ product.skuNumber }>
                                    Buy perpetual license
                                </a> for <ProductPriceFormat price={ product.skuPrice } />
                            </div>
                        }
                    </>
                }

                {
                    props.isCompareVisible &&
                    <CompareProducts
                        documentID={ product.documentID }
                        callback={ props.compareCallback }
                        compareType={ props.compareType }
                    />
                }

            </div>
            {showSubscriptionPopup && <PlansPopupExported close={() => setShowSubscriptionPopup(false)} product={props?.product} sbsIncludedIn={props?.product?.sbsIncludedIn} />}
        </div>
    )
};

export default ListProduct;